module.exports = ".msgScore {\n  color: #af0202 !important;\n  font-size: 14px; }\n  .msgScore mat-hint {\n    color: #af0202 !important; }\n"